import React from "react";
import "./AboutCover.css";

import TeamImage from "../../assets/aboutus/about-team-image.png";
import image_fill from "../../assets/aboutus/image_fill.png";
import { motion } from "framer-motion";

const AboutCover = () => {
  const data = [
    {
      header: "Speed with Precision",
      txet: "We don't just move fast; we deliver fast without cutting corners. Expect top-notch quality, always on time. ",
    },
    {
      header: "Client-First Communication",
      txet: "Our highly skilled professionals are dedicated to delivering work that aligns with your mission to provide the best solutions that meet your needs.",
    },
    {
      header: "Tailored, Not Templated",
      txet: "Our digital team mixes experience with cultural knowledge from Washington D.C. to the South Cone to offer a fresh, innovative perspective.",
    },
    {
      header: "Fueled by Results, Not Aesthetics",
      txet: "Alone Appearance matters, but making it to the other side matters more. Every pixel we set and feature we develop has one purpose: To grow your business..",
    },
  ];
  return (
    <section className="aboutcover-section">
      <div className="aboutcover-text">
        <h1>
          Your Success is Our <span className="aboutcover-bold">Code</span>
          <span className="aboutcover-highlight">!</span>
        </h1>
        <h2>
          <span className="aboutcover-italic-orange">Let’s Grow</span>{" "}
          <span className="aboutcover-bold">Digitally,</span>{" "}
          <span className="aboutcover-italic-orange">together.</span>
        </h2>
      </div>
      <div className="aboutcover-image-container">
        <img
          src={TeamImage}
          alt="Team"
          className="aboutcover-image"
          onLoad={(e) => e.currentTarget.classList.add("show")}
        />
      </div>
      <div className="aboutcover-extra-container">
        <div>
          <motion.div
                      initial={{ opacity: 0, y: 100 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.8 }}
                      viewport={{ once: true }}
                    >
          <p className="make-diff-header">What makes us different</p>
          <p>Driven by possibility. Motivated by progress. </p>
          </motion.div>
          <div className="zigzag-container">
            {/* Background image for entire section */}
            <div
              className="zigzag-bg-image"
              // style={{
              //   backgroundImage: `url(${image_fill})`,
              // }}
            >
              <img src={image_fill} style={{ width: "inherit" }} />
            </div>

            {/* Map data dynamically */}
            {data.map((section, index) => (
              <div
                  key={index}
                  className={`inner-about-diff ${
                    index % 2 === 0 ? "left" : "right"
                  }`}
                >
                    <motion.div
                      initial={{ opacity: 0, y: 100 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.8 }}
                      viewport={{ once: true }}
                    >
                  <p className="inner-header">{section.header}</p>
                  <p className="inner-text">{section.txet}</p>
              </motion.div>
                </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCover;
